import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import APIHandler from './../utilities/apiHandler.js';
import errorImg from './../assets/img/error.png';
import successImg from './../assets/img/success.png';
import FileSaver from 'file-saver';
 

export default class FileUploaderBlob extends Component{
	constructor(props) {
		super(props);
		this.state = {
			file: null,
			uploading: false,
			uploadStatus: null
		};
		this.setUploadStatus = this.setUploadStatus.bind(this);
		this.clear = this.clear.bind(this);
	}

	setUploadStatus(isSuccess, message) {
		this.setState({
			uploading: false
		})
		var status;
		if (isSuccess) {
            status = {
                title: 'File uploaded successfully.',
                statusCss: 'success-text',
                icon: successImg,
                message: ['Please check the downloaded file']
            };
        } else {

            if (!message) {
                status = {
                    title: 'File upload cancelled!',
                    statusCss: 'failure-text',
                    icon: errorImg,
                    message: ['Cancelled by user.']
                };
            } else {
                status = {
                    title: 'Error uploading file',
                    statusCss: 'failure-text',
                    icon: errorImg,
                    message: message.error
                };
            }
        }
        this.setState({
        	uploadStatus: status
        })
	}

	onDrop(files) {
		var file = files[0];
		if(file) {
			this.setState({
				file: file,
				uploading: true
			})
		}
		var URL = this.props.url;
		var formData = new FormData();
		formData.append('file', file);
		APIHandler.postIngestionBlob(URL, formData)
		.then(function(response) {
			response.data.blob().then(function(data) {
				var blob = new Blob([data], {
                	type: response.mime
            	});
            	FileSaver.saveAs(blob, response.name);
			})
			this.setUploadStatus(true, 'hi');
		}.bind(this)).catch(function(error) {
			this.setUploadStatus(false, error.error);
		}.bind(this)).finally(function(evt) {
		});

	}

	showMessage(message) {
		if(typeof(message) === 'string') {
			return <span>{message}</span>
		}
		const abc = message.map((msg,index) => {
			return <span key={index}>{msg}<br/></span>
		});
		return abc;
	}

	clear() {
        if (!this.state.uploading) {
            this.setState({
            	file: null,
				uploadStatus: null
            });
        }
    }

	cancelUpload() {
		alert('hello');
	}

	render() {
		let dropzoneRef;
		return (
			<div className="drop-outer-box">
				<div style={{marginBottom:'10px',color:'#666', opacity:'0.8'}}>
					Please Upload your file here :
				</div>
				<Dropzone ref={(node) => { dropzoneRef = node; }} onDrop={(files) => this.onDrop(files)} className="drop-wrapper" disableClick={true}>
				{(!this.state.file)?
					<div>
	                	<div className="drop-instruction">
	                		Drag and Drop file here
	                	</div>
	                	<div className="drop-instruction">
	                		OR
	                	</div>
	                	<div className="drop-instruction" style={{padding:'10px'}}>
	                		<span className="choose-file" onClick={() => { dropzoneRef.open() }}>Choose file</span>
	                	</div>
                	</div>
                	:null
                }
                {(this.state.uploading && !this.state.uploadStatus)?
                	<div>
                		<div className="drop-instruction">
	                		Uploading...
	                	</div>
	            		<div className="drop-instruction">
	            			<small className="text-muted">{this.state.file.name}</small>
	            		</div>
	            		<div className="drop-instruction">
	            			<button className="btn btn-primary" onClick={this.cancelUpload}>Cancel</button>
	            		</div>
	            	</div>:null
	            }
	            {(this.state.uploadStatus)?
                	<div>
                		<p className={"left upload-status "+this.state.uploadStatus.statusCss}>
				            <img src={this.state.uploadStatus.icon} alt="upload icon"/>
				            <b>{this.state.uploadStatus.title}</b>
				            <br/>
				            <span>{this.showMessage(this.state.uploadStatus.message)}</span>
				        </p>
				        <button className="btn btn-default" onClick={this.clear} style={{marginTop:'50px'}}>Upload Again</button>
	            	</div>:null
	            }
				</Dropzone>
				<div style={{marginTop:'10px',color:'#666', opacity:'0.8'}}>
					<span style={{color:'red'}}>Note:</span> Please Upload only .xlsx files
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/commons/FileUploaderBlob.js